(function () {
    'use strict';

    angular
        .module('dialog-manager')
        .factory('action-dm-open-dialog', actionOpenDialog);

    function actionOpenDialog(DialogManager, lodash, $q) {
        return function (options, eventData, actionData) {
            return $q.when(run());

            function run() {
                if (lodash.get(options, 'remote_dialog_options', false) !== true) {
                    let dialogId = lodash.get(options, 'dialog_id', null);
                    if (!dialogId) dialogId = new Date().getTime();

                    if (!canOpenDialog(dialogId)) { return false; }
                    lodash.set(options, 'dialog_options.eventData', eventData);
                    lodash.set(options, 'dialog_options.actionData', actionData);
                    return DialogManager.init(dialogId, options);
                } else {
                    let dialogId = lodash.get(actionData.data, 'dialog_id', null);
                    if (!dialogId) dialogId = new Date().getTime();
                    if (!canOpenDialog(dialogId)) { return false; }
                    return DialogManager.init(dialogId, actionData.data);
                }

            }

            function canOpenDialog(dialogId) {
                if (!lodash.get(options, 'allow_duplicate', false)) {
                    return !(DialogManager.hasDialog(dialogId));
                }
            }
        };
    }
})();
